import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { urlConfig } from '../shared/constants/url-config';
import { FloorPlanImagesDto } from '../shared/dynamicform/models/common-models';
import { CustomGuestFieldsModel, FinancialEffectForUpdatedReservationDTO, RegisterReservationAttemptResponseDTO, ReservationAttemptBasicInfo, ReservationDTO, ReservationInfoDTO } from '../shared/Models/PartyModels';
import { SessionBookingDTO } from '../shared/Models/SessionBookingDTO';
import { operationType, WidgetSettingsDTO } from '../shared/Models/WidgetSettingsModels';
import { HttpService } from '../shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesService {
  public restaurantWidgetName: string;
  public restaurantWidgetId: number;
  public reservationToken: any;
  public operation = operationType.create;
  public language: any;
  public countriesList: any[];
  public LocationList: any[];
  public InstructorList: any[];
  public customGuestFields: any;
  public SessionBookingObj: SessionBookingDTO;
  public SaveBookingObj: any = {};
  public SelectedActivity: any;
  public selectedGuest: any;
  public ispaymentInvolvedInfo: any;
  public reservationAttemptInfo: any;
  public message: string;
  public reservationConfirmationText: string;
  public additionalGuestPage: any;
  slotLockId: number;
  public restaurantImages: BehaviorSubject<FloorPlanImagesDto> = new BehaviorSubject<FloorPlanImagesDto>(null);
  restaurantWidgetSettings$ = new BehaviorSubject<WidgetSettingsDTO>(null);
  allClassActivitiesAvailable$ = new BehaviorSubject<any>(null);
  editPartyData$ = new BehaviorSubject<any>(null);
  createActivityResponse$ = new BehaviorSubject<any>(null);
  RatePlanList$ = new BehaviorSubject<any>(null);
  formValid$: Subject<any> = new Subject<any>();
  TabChange$: Subject<any> = new Subject<any>();
  bookingType$: Subject<any> = new Subject<any>();
  dataRetentionPolicy$: Subject<any> = new Subject<any>();
  globaactivityServiceeatingAreaId: number;
  subscriptions: Subscription = new Subscription();
  partySize: number;
  PaymentData$: Subject<any> = new Subject<any>();
  FormChanged: Subject<any> = new Subject<any>();
  constructor(private httpService: HttpService) { }

  getRestaurantImages(restaurantId) {
    this.httpService.get(urlConfig.getImages + restaurantId).subscribe((images) => {
      const allAvailableImages = images.Payload as FloorPlanImagesDto;
      this.restaurantImages.next(allAvailableImages);
    });
  }

  getWidgetSettingsByRestaurantName(restaurantName: string) {
    return this.httpService.get(`${urlConfig.getWidgetSettings}?restaurantName=${restaurantName}`).pipe(
      map((data: any) => data.Payload as WidgetSettingsDTO));
  }

  lockSessions(restaurantId, reqObj) {
    return this.httpService.post(`${urlConfig.lockSessionsURL}?restaurantId=${restaurantId}`, reqObj)
  }

  getWidgetSettingsByRestaurantId(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.getWidgetSettings}?restaurantId=${restaurantId}`).pipe(
      map((data: any) => data.Payload as WidgetSettingsDTO));
  }

  GetCustomFields(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.getCustomGuestFields}?restaurantId=${restaurantId}`).pipe(map((data: any) => data.Payload as CustomGuestFieldsModel));
  }

  getByToken(token: string) {
    return this.httpService.get(`${urlConfig.getByToken}?token=${token}`).pipe(map((data: any) => data.Payload as ReservationDTO));
  }
  GetCountries() {
    return this.httpService.get(`${urlConfig.getCountries}`).pipe(map((data: any) => data.Payload));
  }

  GetClassSlots(req): Observable<any> {
    return this.httpService.post(`${urlConfig.GetSlotsForActivityURL}?restaurantId=${req.PropertyId}&options=0`, req);
  }

  GetSessionRatePlanCalculated(RestaurantId, request) {
    return this.httpService.post(`${urlConfig.GetRatePlanCalculatedURL}?restaurantId=${RestaurantId}&options=0`, request)
  }

  GetPreliminaryReservationInformation(SpecialMealId) {
    return this.httpService.post(`${urlConfig.GetPreliminaryActivityInformationURL}?restaurantId=${this.restaurantWidgetId}&specialMealId=${SpecialMealId}`, '').pipe(map((data: any) => data.Payload as ReservationInfoDTO));

  }
  GetRegisterReservationAttempt(reservationAttemptId: Number) {
    return this.httpService.get(`${urlConfig.getReservationAttemptState}?reservationAttemptId=${reservationAttemptId}`).pipe(map((data: any) => data.Payload as ReservationAttemptBasicInfo));
  }

  UpdateReservationAttempt(PaymentCallbackRequest) {
    return this.httpService.post(urlConfig.updateReservationAttempt, PaymentCallbackRequest)
  }


  RegisterReservationAttempt(RegisterReservationAttemptRequestDTO) {
    return this.httpService.post(urlConfig.registerBookActivityAttempt + '?restaurantId=' + this.restaurantWidgetId, RegisterReservationAttemptRequestDTO).pipe(map((data: any) => data.Payload as RegisterReservationAttemptResponseDTO))
  }


  createSessionBooking(request) {
    request.PageMethod = request.Contact.PreferredPageMethod;
    return this.httpService.post(`${urlConfig.createSessionBookingURL}?restaurantId=${this.restaurantWidgetId}`,
      request).pipe(map((data: any) => data.Payload));
  }

  updateSessionBooking(request) {
    request.PageMethod = request.Contact.PreferredPageMethod;
    return this.httpService.post(`${urlConfig.updateSessionBookingURL}?restaurantId=${this.restaurantWidgetId}`,
      request).pipe(map((data: any) => data.Payload));
  }
  GetFilterValues(req): Observable<any> {
    // return;
    return this.httpService.post(`${urlConfig.getGetFilteredLessonsActivityURL}?restaurantId=${this.restaurantWidgetId}`, req);
  }

  GetFinancialEffectCalculation(reservationDTO) {
    return this.httpService.post(urlConfig.getFinancialEffectForUpdatedActivityDTO + '?restaurantId=' + this.restaurantWidgetId, reservationDTO).pipe(map((data: any) => data.Payload as FinancialEffectForUpdatedReservationDTO));
  }

  CancelBooking(restaurantId:Number,partyId:Number,language:Number){
    return this.httpService.post(`${urlConfig.cancelSessionBooking}?restaurantId=${restaurantId}&partyId=${partyId}&cancelAllOrRemainingSessions=true&language=${language}`);
  }

  getCancellationCharge(restaurantId:Number,partyId: number, cancelAllOrRemainingSessions: boolean, bookedSessionId: number = null) {
    return this.httpService.get(
      `${urlConfig.GetCancellationChargeURL}?restaurantId=${restaurantId}&partyId=${partyId}&cancelAllOrRemainingSessions=${cancelAllOrRemainingSessions}&bookedSessionId=${bookedSessionId}`);
  }

}
